import KendoDataSource from '../KendoDataSource'
import KendoHierarchicalDataSource from '../KendoHierarchicalDataSource'
import KendoSchedulerDataSource from '../KendoSchedulerDataSource'
import KendoTreeListDataSource from '../KendoTreeListDataSource'
import KendoGanttDataSource from '../KendoGanttDataSource'
import KendoGanttDependencyDataSource from '../KendoGanttDependencyDataSource'
import KendoPivotDataSource from '../KendoPivotDataSource'
import KendoPivotColumn from '../KendoPivotColumn'
import KendoPivotMeasure from '../KendoPivotMeasure'
import KendoPivotRow from '../KendoPivotRow'

let KendoDataSourceInstaller = class {
    static install(Vue) {
        Vue.component(KendoDataSource.name, KendoDataSource)
        Vue.component(KendoHierarchicalDataSource.name, KendoHierarchicalDataSource)
        Vue.component(KendoSchedulerDataSource.name, KendoSchedulerDataSource)
        Vue.component(KendoTreeListDataSource.name, KendoTreeListDataSource)
        Vue.component(KendoGanttDataSource.name, KendoGanttDataSource)
        Vue.component(KendoGanttDependencyDataSource.name, KendoGanttDependencyDataSource)
        Vue.component(KendoPivotDataSource.name, KendoPivotDataSource)
        Vue.component(KendoPivotColumn.name, KendoPivotColumn)
        Vue.component(KendoPivotMeasure.name, KendoPivotMeasure)
        Vue.component(KendoPivotRow.name, KendoPivotRow)
    }
}

export default KendoDataSourceInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDataSourceInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/kendo-datasource-installer/index.js